import Button from '@/common/components/Button'
import Modal from '@/common/components/Modal'
import { FormTransformers } from '@/common/utils/formTransformers'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import useDisableTmaisRaffle from '../hooks/useDisableTmaisRaffle'

interface DisableTmaisRaffleModalProps {
  tmaisRaffleId?: string
}

export const DisableTmaisRaffleModal = ({ tmaisRaffleId }: DisableTmaisRaffleModalProps) => {
  const queryClient = useQueryClient()

  const [isOpen, setIsOpen] = useState(false)

  const { mutate: disableTmaisRaffle } = useDisableTmaisRaffle({
    id: tmaisRaffleId,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tmaisRaffle', tmaisRaffleId] })
      reset()
      setIsOpen(false)
    },
    onError: (error) => FormTransformers.errorsTransformer({ setError })(error),
  })

  const {
    reset,
    setError,
    handleSubmit,
  } = useForm()

  const onSubmit = () => {
    disableTmaisRaffle()
  }

  return (
    <Modal
      Trigger={
        <Button
          operationKlassToCheckPermission="Admin::Tmais::Raffles::Disable"
          type="button"
          variant="outline-error"
        >
          Desativar
        </Button>
      }
      title="Desativar sorteio"
      subtitle="Você tem certeza?"
      subtitleClassName="mt-1 text-white-300"
      useCancellableFooter
      confirmButtonText='Desativar'
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      onConfirm={handleSubmit(onSubmit)}
    />
  )
}
